const { BASE_PATH } = require('../../../../lib/basePath.js');

// Returns a public-folder asset path prefixed with the deployment base path.
// Ensures SVG/PNG/video URLs resolve correctly when deployed at a subpath.
function publicUrl(assetPath) {
  const base = BASE_PATH === '/' ? '' : BASE_PATH;
  if (base && assetPath.startsWith(BASE_PATH)) {
    return assetPath;
  }
  return base + assetPath;
}

module.exports = publicUrl;
